var $7c62000d36213e38$exports = {};
$7c62000d36213e38$exports = {
    "alert": `\u{62A}\u{646}\u{628}\u{64A}\u{647}`,
    "dismiss": `\u{62A}\u{62C}\u{627}\u{647}\u{644}`
};


export {$7c62000d36213e38$exports as default};
//# sourceMappingURL=ar-AE.mjs.map
